export default __webpack_public_path__ + "static/media/wkrecajaceprzed.14bbf1d8.jpeg";